import { UseTableStateParams } from '@vtex/admin-ui'
import type { ArchivedSimplifiedPromotion } from 'typings'
import {
  ArchivedActionsButton,
  BeginDate,
  EndDate,
  Name,
} from '../PromotionsList/Table/Columns'
import {
  FromHeader,
  NameHeader,
  ToHeader,
} from '../PromotionsList/Table/Columns/Headers'

export const archivedPromotionsListColumns: UseTableStateParams<ArchivedSimplifiedPromotion>['columns'] =
  [
    {
      id: 'name',
      header: NameHeader,
      resolver: {
        type: 'plain',
        render: Name,
      },
    },
    {
      id: 'beginDate',
      header: FromHeader,
      width: 200,
      resolver: {
        type: 'plain',
        render: BeginDate,
      },
    },
    {
      id: 'endDate',
      header: ToHeader,
      width: 200,
      resolver: {
        type: 'plain',
        render: EndDate,
      },
    },
    {
      id: 'actions',
      width: 70,
      resolver: {
        type: 'plain',
        render: ArchivedActionsButton,
      },
    },
  ]
